import ApiService from "../../../services/api.service";

const AirCafeProductService = {

	list(search, data) {
		return ApiService.post(`/aircafe-product/list-search?search=${search}`, data);
	},
	create(data) {
		return ApiService.post(`/aircafe-product/create`, data);
	},
	update(data) {
		return ApiService.put(`/aircafe-product/update/${data.id}`, data);
	},
	createPhoto(productId, data) {
		return ApiService.post(`/aircafe-product/add-photo/${productId}`, data);
	},
	deletePhoto(productId, fileId) {
		return ApiService.get(`/aircafe-product/${productId}/remove-photo/${fileId}`);
	},
	changeStatus(item) {
		return ApiService.get(`/aircafe-product/change-status/${item.id}?status=${item.status}`);
	}

}

export default AirCafeProductService
